export function mapFilterKeys(filters, keyMap) {
  const newFilters = { ...filters }

  for (const oldKey in keyMap) {
    const newKey = keyMap[oldKey]

    if (Object.prototype.hasOwnProperty.call(newFilters, oldKey)) {
      newFilters[newKey] = newFilters[oldKey]
      delete newFilters[oldKey]
    }
  }

  return newFilters
}
